




import { Component, Vue } from 'vue-property-decorator'
import storyListCom from './storyListCom.vue'

@Component({
  name: 'storyList',
  components: {
    storyListCom
  }
})
export default class extends Vue {
  dataObj = {
    getListUrl: '/blackcat/story/line/tenant/list',
    directUrl: 'tenantStoryDetail',
    onLineType: 'tenantOnline'
  }
}
